import { Pressable } from '../../../ui/Pressable';
import type { GoogleStatus } from './types';

/** Google Calendar + Tasks (card hWnpJn7Tfl38) — the link the Chores
 *  panel offers before any write can happen. Hidden entirely when this
 *  worker has no Google client, so the panel never shows a button that
 *  cannot work. */
export function GoogleCard({ google, gBusy, gNote, connectGoogle, disconnectGoogle }: {
  google: GoogleStatus | null;
  gBusy: boolean;
  gNote: string | null;
  connectGoogle: () => Promise<void>;
  disconnectGoogle: () => Promise<void>;
}) {
  return (
    <div className="rq-card ch-google" id="ch-google">
      <p className="rq-composer-label">Google Calendar &amp; Tasks</p>
      <p className="rq-empty-hint ch-google-status" id="ch-google-status">
        {google === null && 'Checking the Google link…'}
        {google !== null && !google.configured && 'Not linked on this build — a Google connection is not configured here.'}
        {google?.configured && !google.connected &&
          'Sign in with the account in which you’d like the task reminders to appear — a chore then lands on that account’s calendar and task list.'}
        {google?.connected &&
          `Connected${google.accountEmail ? ` as ${google.accountEmail}` : ''} — ${google.scopes.includes('https://www.googleapis.com/auth/calendar') ? 'calendar and tasks' : 'tasks'} granted.`}
      </p>
      {gNote && <p className="rq-empty-hint ch-google-note" id="ch-google-note" role="status">{gNote}</p>}
      {google?.configured && (google.connected ? (
        <Pressable
          className="pear-btn ch-google-btn"
          id="ch-google-disconnect"
          disabled={gBusy}
          onClick={() => void disconnectGoogle()}
        >
          {gBusy ? '…' : 'Disconnect Google'}
        </Pressable>
      ) : (
        <Pressable
          className="pear-btn pear-btn-mustard ch-google-btn"
          id="ch-google-connect"
          disabled={gBusy}
          onClick={() => void connectGoogle()}
        >
          {gBusy ? '…' : 'Connect Google'}
        </Pressable>
      ))}
    </div>
  );
}
